(() => {
  const main = document.getElementById('MainContent');
  if (!main || main.querySelector('[data-roll-page]')) return;
  const marketContext = JSON.parse(document.getElementById('ink-market-context')?.textContent || '{}');
  const helpfulBreakpoint = window.matchMedia('(max-width: 640px)');
  const regionalCopy = (value) => {
    if (typeof value !== 'string' || !marketContext.country) return value;
    const sizeLabel = (size) => marketContext.regional
      ? Number((Number(size) * 25.4).toFixed(1)) + ' mm (' + size + ' in)'
      : size + ' in (' + Number((Number(size) * 25.4).toFixed(1)) + ' mm)';
    let output = value.replace(/(?:Up to |up to )?(\d+(?:\.\d+)?) inches on the longest side/g, (_, size) => 'Up to ' + sizeLabel(size) + ' on the longest side').replace(/final (\d+(?:\.\d+)?)-inch print size/g, (_, size) => 'final ' + sizeLabel(size) + ' print size');
    if (marketContext.country === 'CA') output = output.replace(/\bcolor(s|ful)?\b/g, 'colour$1').replace(/\bColor(s|ful)?\b/g, 'Colour$1');
    if (marketContext.country === 'GB') output = output.replace(/\bcolor(s|ful)?\b/g, 'colour$1').replace(/\bColor(s|ful)?\b/g, 'Colour$1').replace(/\bfulfillment\b/g, 'fulfilment').replace(/\blabeling\b/g, 'labelling').replace(/\borganized\b/g, 'organised');
    return output;
  };
  const isMatteLanding = main.classList.contains('theme-template-suffix-landing-matte-jolie');
  const pageLocale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  if (isMatteLanding) main.classList.add('theme-template-suffix-landing-deal-test');
  if (!isMatteLanding && !main.classList.contains('theme-template-suffix-landing-deal-test') && !main.classList.contains('theme-template-suffix-landing-outdoor-test')) return;
  const isDeal = isMatteLanding || main.classList.contains('theme-template-suffix-landing-deal-test');
  const isGloss100Deal = main.classList.contains('theme-template-suffix-deal-100-2-gloss') || /\/100-2-gloss-custom-vinyl-stickers(?:\/|$)/.test(window.location.pathname);
  const is500Deal = isDeal && /\/500-2-gloss-custom-vinyl-stickers(?:\/|$)/.test(window.location.pathname);
  const isLargeGlossDeal = isDeal && /\/50-6-gloss-custom-vinyl-stickers(?:\/|$)/.test(window.location.pathname);
  const isMatte200Deal = isDeal && /\/200-3-matte-custom-vinyl-stickers(?:-qa-variant-pricing-v2)?(?:\/|$)/.test(window.location.pathname);
  const productHandle = main.querySelector('[data-shopify-product-handle]')?.dataset.shopifyProductHandle || '';
  const isRoll2000Deal = isDeal && (productHandle === '2000-2-5-gloss-custom-vinyl-roll-labels' || /\/2000-2-5-gloss-custom-vinyl-roll-labels(?:\/|$)/.test(window.location.pathname));
  const rollDealSize = productHandle === '1000-2-5-gloss-custom-vinyl-roll-labels' ? 2.5 : productHandle === '1000-3-gloss-custom-vinyl-roll-labels' ? 3 : 2;
  const isNewRollDeal = ['1000-2-5-gloss-custom-vinyl-roll-labels', '1000-3-gloss-custom-vinyl-roll-labels'].includes(productHandle);
  const isRoll1000Deal = isDeal && (isRoll2000Deal || isNewRollDeal || productHandle === '1000-2-gloss-custom-vinyl-roll-labels' || /\/1000-2-gloss-custom-vinyl-roll-labels(?:-qa-variant-pricing-v2)?(?:\/|$)/.test(window.location.pathname));
  const isClear200Deal = main.classList.contains('theme-template-suffix-deal-200-clear') || /\/200-2-5-custom-clear-stickers(?:\/|$)/.test(window.location.pathname);
  const isHolographic250Deal = main.classList.contains('theme-template-suffix-deal-250-holographic') || main.classList.contains('theme-template-suffix-deal-300-holographic') || /\/(?:250-3|300-2-5)-custom-holographic-stickers(?:\/|$)/.test(window.location.pathname);
  const isTransferDeal = /\/custom-transfer-stickers(?:\/|$)/.test(window.location.pathname);
  const fixedGloss = main.querySelector('[data-ink-gloss-profile]');
  const dealProfile = fixedGloss
    ? { quantity: Number(fixedGloss.dataset.quantity), size: Number(fixedGloss.dataset.size), surface: fixedGloss.dataset.surface }
    : isGloss100Deal
        ? { quantity: 100, size: 2, surface: 'Waterproof gloss vinyl', badge: '100 PCS · 2-INCH GLOSS', bottomBadge: 'ONE DESIGN · CUSTOM CUT' }
      : isClear200Deal
        ? { quantity: 200, size: 2.5, surface: 'Transparent clear vinyl', badge: '200 PCS · 2.5-INCH CLEAR', bottomBadge: 'ONE DESIGN · TRANSPARENT EFFECT' }
      : isHolographic250Deal
        ? { quantity: 300, size: 2.5, surface: 'Color-shifting holographic vinyl', badge: '300 PCS · 2.5-INCH HOLOGRAPHIC', bottomBadge: 'ONE DESIGN · RAINBOW SHIFT' }
      : isTransferDeal
        ? { quantity: '50–1,000', size: 5, surface: 'Pressure-applied full-color transfer', badge: 'CUSTOM TRANSFER STICKERS', bottomBadge: 'PRESS · BURNISH · PEEL' }
      : isMatte200Deal
        ? { quantity: 200, size: 3, surface: 'Matte or Glossy vinyl finish', badge: '200 PCS · UP TO 3 INCH' }
    : isRoll2000Deal
      ? { quantity: 2000, size: 2.5, surface: 'Gloss vinyl face + efficient roll format', badge: '2,000 PCS · 2.5-INCH ROLL LABELS' }
    : isRoll1000Deal
      ? { quantity: 1000, size: rollDealSize, surface: 'Gloss vinyl face + efficient roll format', badge: `1,000 PCS · ${rollDealSize}-INCH ROLL LABELS` }
      : is500Deal
    ? { quantity: 500, size: 2, surface: 'Gloss PVC face + removable adhesive', badge: '500 PCS · UP TO 2 INCH' }
    : isLargeGlossDeal
      ? { quantity: 50, size: 6, surface: 'Gloss PVC face + removable adhesive', badge: '50 PCS · 6-INCH GLOSS' }
      : { quantity: 100, size: 3, surface: 'Gloss PVC face + removable adhesive', badge: '100 PCS · UP TO 3 INCH' };

  const replaceExactPageCopy = (replacements) => {
    const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script, style')) continue;
      let value = node.nodeValue;
      replacements.forEach(([from, to]) => { value = value.replace(from, to); });
      if (value !== node.nodeValue) node.nodeValue = value;
    }
    main.querySelectorAll('[alt], [aria-label]').forEach((element) => {
      ['alt', 'aria-label'].forEach((attribute) => {
        if (!element.hasAttribute(attribute)) return;
        let value = element.getAttribute(attribute);
        replacements.forEach(([from, to]) => { value = value.replace(from, to); });
        element.setAttribute(attribute, value);
      });
    });
  };

  const setSeo = (title, description) => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', description);
  };

  if (isTransferDeal) {
    replaceExactPageCopy([[/A Printed-On Finish/g, 'a Printed-On Finish']]);
    setSeo(
      'Custom Transfer Stickers | Inkelligent',
      'Order custom transfer stickers and vinyl transfer stickers in 2- to 5-inch sizes. Upload one design for logo transfer stickers and review a digital proof.'
    );
  } else if (isClear200Deal) {
    setSeo(
      'Custom Clear Stickers – 200 at 2.5 Inches | Inkelligent',
      'Order 200 custom clear stickers at 2.5 inches in a fixed 200-piece pack. These transparent vinyl stickers create a clear-background look for logos, glass and packaging.'
    );
  } else if (isHolographic250Deal) {
    const holographicReplacements = [
      [/250 PCS · 3-INCH HOLOGRAPHIC/g, '300 PCS · 2.5-INCH HOLOGRAPHIC'],
      [/250 3" Custom Holographic Stickers/g, '300 2.5" Custom Holographic Stickers'],
      [/250 matching 3-inch stickers/g, '300 matching 2.5-inch stickers'],
      [/250 custom holographic stickers, printed at 3 inches/g, '300 custom holographic stickers, printed at 2.5 inches'],
      [/250 custom holographic vinyl stickers in a 3-inch format/g, '300 custom holographic vinyl stickers in a 2.5-inch format'],
      [/250-piece holographic sticker order/g, '300-piece holographic sticker order'],
      [/up to 3 inches on the longest side/g, 'up to 2.5 inches on the longest side'],
      [/3-inch format/g, '2.5-inch format']
    ];
    replaceExactPageCopy(holographicReplacements);
    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      let value = script.textContent;
      holographicReplacements.forEach(([from, to]) => { value = value.replace(from, to); });
      if (value !== script.textContent) script.textContent = value;
    });
    setSeo(
      'Custom Holographic Stickers – 300 at 2.5 Inches | Inkelligent',
      'Order 300 custom holographic stickers at 2.5 inches in a fixed 300-piece pack. These color-shifting holo stickers work for logos, packaging and holographic labels.'
    );
  }

  const matte200UiByLocale = {
    en: { selectFinish: 'Select Finish', matte: 'Matte', matteDescription: 'Soft, low-reflection finish', glossy: 'Glossy', glossyDescription: 'Bright, polished finish', highlights: ['200 custom stickers', 'Up to 3 inches on the longest side', 'Matte or Glossy vinyl finish', 'Artwork checked before production'], highlightsLabel: 'Product highlights', unitNote: '', policyLabel: 'Shipping and return policies', freeShipping: 'Free Shipping', freeShippingBefore: 'Free shipping is available. For additional information, view our ', shippingPolicy: 'shipping policy', returnPolicy: 'Return Policy', returnBefore: '30-Day Money Back Guarantee. For more details, view our ', refundPolicy: 'Return & Refund Policy', helpful: 'Helpful Details Before You Order', chooseImage: 'Choose a product image', viewImage: 'View product image', moreViews: 'More Views', galleryHint: 'Choose an image or use the arrows' },
    fr: { selectFinish: 'Choisir la finition', matte: 'Mate', matteDescription: 'Finition douce et peu réfléchissante', glossy: 'Brillante', glossyDescription: 'Finition lumineuse et polie', highlights: ['200 autocollants personnalisés', 'Jusqu’à 7,6 cm sur le côté le plus long', 'Finition vinyle mate ou brillante', 'Visuel vérifié avant production'], highlightsLabel: 'Points forts du produit', unitNote: '', policyLabel: 'Livraison et retours', freeShipping: 'Livraison gratuite', freeShippingBefore: 'La livraison gratuite est disponible. Pour en savoir plus, consultez notre ', shippingPolicy: 'politique de livraison', returnPolicy: 'Politique de retour', returnBefore: 'Garantie satisfait ou remboursé de 30 jours. Pour en savoir plus, consultez notre ', refundPolicy: 'politique de remboursement', helpful: 'Informations utiles avant de commander', chooseImage: 'Choisir une image du produit', viewImage: 'Afficher l’image du produit', moreViews: 'Plus de vues', galleryHint: 'Choisissez une image ou utilisez les flèches' },
    de: { selectFinish: 'Oberfläche wählen', matte: 'Matt', matteDescription: 'Weiche, reflexionsarme Oberfläche', glossy: 'Glänzend', glossyDescription: 'Helle, polierte Oberfläche', highlights: ['200 individuelle Aufkleber', 'Bis zu 3 Zoll an der längsten Seite', 'Matte oder glänzende Vinyloberfläche', 'Druckdatenprüfung vor der Produktion'], highlightsLabel: 'Produktvorteile', unitNote: '', policyLabel: 'Versand und Rückgabe', freeShipping: 'Kostenloser Versand', freeShippingBefore: 'Kostenloser Versand ist verfügbar. Weitere Informationen finden Sie in unseren ', shippingPolicy: 'Versandbedingungen', returnPolicy: 'Rückgabebedingungen', returnBefore: '30 Tage Geld-zurück-Garantie. Weitere Informationen finden Sie in unseren ', refundPolicy: 'Rückerstattungsbedingungen', helpful: 'Wichtige Informationen vor der Bestellung', chooseImage: 'Produktbild auswählen', viewImage: 'Produktbild anzeigen', moreViews: 'Weitere Ansichten', galleryHint: 'Wählen Sie ein Bild oder verwenden Sie die Pfeile' }
  };
  const matte200Ui = matte200UiByLocale[pageLocale] || matte200UiByLocale.en;

  if (marketContext.unitNote) matte200Ui.unitNote = marketContext.unitNote;
  if (marketContext.country) {
    matte200Ui.highlights = matte200Ui.highlights.map(regionalCopy);
    matte200Ui.freeShipping = marketContext.shippingTitle;
    matte200Ui.freeShippingBefore = marketContext.shippingBody;
  }

  const helpfulDetailsByLocale = {
    en: {
      heading: 'Helpful Details Before You Order',
      designTitle: 'Design Tips',
      resolution: (size) => `Prepare artwork at 300 DPI at the final print size (up to ${size} inches on the longest side).`,
      color: 'Use CMYK color mode when possible. Screen color can differ slightly from printed color.',
      detail: 'Keep small text, fine lines, borders, and narrow cut areas thick enough to print and apply cleanly.',
      proofTip: 'Review spelling, scale, color, border, and cut shape carefully on the digital proof.',
      artworkTitle: 'Artwork & Digital Proof',
      artworkBody: 'Upload one design using the highest-quality file available. We check print readiness and send a digital proof before production begins.',
      shippingTitle: 'Free Shipping',
      shippingBefore: 'Free shipping is available. Delivery timing begins after proof approval and production. Review our ',
      shippingLink: 'shipping policy',
      returnsTitle: 'Return Policy',
      returnsBefore: 'This item is custom-made. If it arrives defective, damaged, incorrect, missing, or materially different from the approved proof, review our ',
      returnsLink: 'Return & Refund Policy',
      returnsAfter: ' for eligibility and next steps.'
    },
    fr: {
      heading: 'Informations utiles avant de commander',
      designTitle: 'Conseils pour votre design',
      resolution: (size) => `Préparez votre fichier à 300 ppp à la taille finale d'impression (jusqu'à ${size} pouces sur le côté le plus long).`,
      color: 'Utilisez le mode colorimétrique CMJN si possible. Les couleurs à l’écran peuvent légèrement différer à l’impression.',
      detail: 'Prévoyez une épaisseur suffisante pour les petits textes, les traits fins, les bordures et les zones de découpe étroites.',
      proofTip: 'Vérifiez attentivement l’orthographe, l’échelle, les couleurs, la bordure et la forme de découpe sur le BAT numérique.',
      artworkTitle: 'Fichier et BAT numérique',
      artworkBody: 'Téléversez un seul design dans la meilleure qualité disponible. Nous vérifions le fichier et envoyons un BAT numérique avant le début de la production.',
      shippingTitle: 'Livraison gratuite',
      shippingBefore: 'La livraison gratuite est disponible. Le délai de livraison commence après l’approbation du BAT et la production. Consultez notre ',
      shippingLink: 'politique de livraison',
      returnsTitle: 'Politique de retour',
      returnsBefore: 'Cet article est fabriqué sur mesure. S’il arrive défectueux, endommagé, incorrect, incomplet ou sensiblement différent du BAT approuvé, consultez notre ',
      returnsLink: 'politique de retour et de remboursement',
      returnsAfter: ' pour connaître les conditions et la marche à suivre.'
    },
    de: {
      heading: 'Wichtige Informationen vor der Bestellung',
      designTitle: 'Tipps für Druckdaten',
      resolution: (size) => `Legen Sie die Druckdatei in Endgröße mit 300 dpi an (bis zu ${size} Zoll an der längsten Seite).`,
      color: 'Verwenden Sie nach Möglichkeit den CMYK-Farbmodus. Bildschirmfarben können leicht vom Druckergebnis abweichen.',
      detail: 'Achten Sie darauf, dass kleine Schrift, feine Linien, Ränder und schmale Schnittbereiche stark genug angelegt sind.',
      proofTip: 'Prüfen Sie Rechtschreibung, Größe, Farbe, Rand und Schnittform sorgfältig im digitalen Korrekturabzug.',
      artworkTitle: 'Druckdatei & Korrekturabzug',
      artworkBody: 'Laden Sie ein Motiv in der bestmöglichen Qualität hoch. Wir prüfen die Druckfähigkeit und senden vor Produktionsbeginn einen digitalen Korrekturabzug.',
      shippingTitle: 'Kostenloser Versand',
      shippingBefore: 'Kostenloser Versand ist verfügbar. Die Lieferzeit beginnt nach Freigabe des Korrekturabzugs und der Produktion. Lesen Sie unsere ',
      shippingLink: 'Versandbedingungen',
      returnsTitle: 'Rückgabebedingungen',
      returnsBefore: 'Dieser Artikel wird individuell angefertigt. Falls er fehlerhaft, beschädigt, falsch, unvollständig oder deutlich anders als der freigegebene Korrekturabzug ankommt, lesen Sie unsere ',
      returnsLink: 'Rückgabe- und Erstattungsbedingungen',
      returnsAfter: ' zu Voraussetzungen und nächsten Schritten.'
    }
  };
  const helpfulDetailsUi = isRoll1000Deal
    ? {
        ...helpfulDetailsByLocale.en,
        heading: 'Helpful Details for Your Roll Label Order',
        designTitle: 'Design & Roll Setup Tips',
        resolution: (size) => `Prepare artwork at 300 DPI at the final ${size}-inch print size.`,
        detail: 'Keep small text, fine lines, borders, and narrow cut areas thick enough to print and dispense cleanly.',
        coreTip: 'All core sizes use a sturdy kraft paper tube. Roll core diameter refers to the tube’s inner diameter—not the label shape or finished label size.',
        proofTip: 'Check spelling, scale, cut shape, label orientation, and the Top / Bottom / Right / Left unwind direction before submitting your artwork.',
        artworkTitle: 'Artwork File & Roll Details',
        artworkBody: 'Upload one design using the highest-quality file available. We check print readiness, cut shape, label orientation, and selected roll details before production.',
        shippingBefore: isRoll2000Deal
          ? 'Free shipping is included with this 2,000-label offer. Delivery timing begins after production. Review our '
          : 'Free shipping is included with this 1,000-label offer. Delivery timing begins after production. Review our ',
        returnsBefore: 'This item is custom-made. If it arrives defective, damaged, incorrect, missing, or materially different from the approved order details, review our '
      }
    : isMatte200Deal
      ? (helpfulDetailsByLocale[pageLocale] || helpfulDetailsByLocale.en)
      : helpfulDetailsByLocale.en;

  if (marketContext.country) {
    helpfulDetailsUi.shippingTitle = marketContext.shippingTitle;
    helpfulDetailsUi.shippingBefore = marketContext.shippingBody;
    helpfulDetailsUi.proofTip = marketContext.proofTip;
    const sourceResolution = helpfulDetailsUi.resolution;
    helpfulDetailsUi.resolution = (size) => regionalCopy(sourceResolution(size));
    for (const key of ['color', 'detail', 'coreTip', 'artworkBody']) {
      if (helpfulDetailsUi[key]) helpfulDetailsUi[key] = regionalCopy(helpfulDetailsUi[key]);
    }
  }

  if (marketContext.country === 'GB') {
    helpfulDetailsUi.returnsBefore = marketContext.returnsBody;
    helpfulDetailsUi.returnsAfter = marketContext.returnsAfter;
    matte200Ui.returnBefore = marketContext.returnsBody;
  }

  const helpfulDetailIcons = {
    design: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18h6M10 22h4M8.3 15.7A7 7 0 1 1 15.7 15.7C14.8 16.5 14.5 17.2 14.5 18h-5c0-.8-.3-1.5-1.2-2.3Z"/><path d="m9.5 10.5 1.7 1.7 3.3-3.6"/></svg>',
    artwork: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 3h11l5 5v13H4z"/><path d="M14 3v6h6M8 14h8M8 18h5"/><path d="m7.5 9 1.4 1.4L12 7.3"/></svg>',
    shipping: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v11H3zM14 10h4l3 4v3h-7z"/><circle cx="7" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>',
    returns: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 7H3V2"/><path d="M3.5 7.5A9 9 0 1 1 3 16"/><path d="M12 7v10M15 9.5c-.8-.8-1.8-1.2-3-1.2-1.6 0-2.8.8-2.8 2 0 3.1 5.6 1.2 5.6 4.3 0 1.2-1.2 2.1-2.8 2.1-1.3 0-2.4-.5-3.2-1.4"/></svg>'
  };

  const enhanceHero = () => {
    const info = main.querySelector('.section-product-info .product-info > .flex');
    const buyBlock = info?.querySelector('.x-block-buy-buttons');
    const rollOptions = main.querySelector('[data-ink-roll-options]');
    const artworkUpload = main.querySelector('.ink-artwork-upload');

    if (is500Deal && artworkUpload) {
      artworkUpload.id = 'ink-gloss-500-upload';
    }

    if (isRoll1000Deal && rollOptions) {
      rollOptions.id = 'ink-roll-customize';
    }

    if (info && buyBlock && !info.querySelector('.ip-hero-benefits')) {
      info.classList.add('ip-hero-info');
      const benefits = isMatte200Deal
        ? matte200Ui.highlights
        : isTransferDeal
          ? ['50–1,000 custom transfer stickers', '2–5 inches on the longest side', 'Optional background removal', 'Artwork checked before production']
        : main.classList.contains('theme-template-suffix-landing-outdoor-test')
        ? ['Waterproof vinyl face stock', 'Made for compatible outdoor surfaces', 'Custom size, quantity & shape', 'Artwork checked before production']
        : isRoll1000Deal
          ? ['Artwork and roll details checked', marketContext.shippingBenefit || 'Free shipping', 'One approved design']
          : [`${dealProfile.quantity} custom stickers`, `Up to ${dealProfile.size} inches on the longest side`, dealProfile.surface, 'Artwork checked before production'];
      const list = document.createElement('ul');
      list.className = 'ip-hero-benefits';
      list.setAttribute('aria-label', isMatte200Deal ? matte200Ui.highlightsLabel : 'Product highlights');
      benefits.map(regionalCopy).forEach((benefit) => {
        const item = document.createElement('li');
        const check = document.createElement('span');
        check.textContent = '✓';
        check.setAttribute('aria-hidden', 'true');
        item.append(check, document.createTextNode(benefit));
        list.append(item);
      });
      buyBlock.before(list);
    }


    if (isMatte200Deal && info && buyBlock) {
      const estimateDelivery = info.querySelector('.x-block-estimate-delivery');
      if (estimateDelivery) {
        estimateDelivery.hidden = true;
        estimateDelivery.setAttribute('aria-hidden', 'true');
        estimateDelivery.classList.add('ip-policy-replaced');
      }

      info.querySelector('.ip-checkout-confidence')?.remove();
    }

    if (isDeal && info) {
      info.querySelector('.x-block-estimate-delivery')?.remove();
      info.querySelector('.ip-checkout-confidence')?.remove();
    }

    if (!isDeal && info && buyBlock && !info.querySelector('.ip-checkout-confidence')) {
      const confidence = document.createElement('ul');
      confidence.className = 'ip-checkout-confidence';
      confidence.setAttribute('aria-label', 'Order assurances');

      const assurances = [
        ['Artwork checked before production', ''],
        [marketContext.shippingBenefit || 'Free shipping', (window.Shopify?.routes?.root || '/') + 'policies/shipping-policy'],
        [marketContext.country === 'GB' ? marketContext.returnsBenefit : '30-day guarantee', (window.Shopify?.routes?.root || '/') + 'policies/refund-policy']
      ];
      assurances.forEach(([label, href]) => {
        const item = document.createElement('li');
        const check = document.createElement('span');
        check.textContent = '✓';
        check.setAttribute('aria-hidden', 'true');
        item.append(check);
        if (href) {
          const link = document.createElement('a');
          link.href = href;
          link.textContent = label;
          item.append(link);
        } else {
          item.append(document.createTextNode(label));
        }
        confidence.append(item);
      });
      buyBlock.after(confidence);
    }

    const heroShell = main.querySelector('.section-product-info .page-width.flex');
    const productSection = heroShell?.closest('.section-product-info');
    const sourceSupportBlocks = info
      ? Array.from(info.querySelectorAll('.accordion, .custom-html, .x-block-social-sharing, .ip-order-policies'))
      : [];
    sourceSupportBlocks.forEach((block) => block.remove());

    if (heroShell && productSection) {
      let support = productSection.querySelector('.ip-after-hero-support');
      if (!support) {
        support = document.createElement('section');
        support.className = 'ip-after-hero-support';
        support.setAttribute('aria-labelledby', 'ip-after-hero-title');
        heroShell.after(support);
      }

      if (support.dataset.ipComplete !== 'true') {
        const makeCard = ({ type, title, body, items, link }) => {
          const isHelpfulAccordion = isRoll1000Deal || is500Deal;
          const card = document.createElement(isHelpfulAccordion ? 'details' : 'article');
          card.className = `ip-helpful-card ip-helpful-card--${type}`;
          if (isHelpfulAccordion) {
            card.open = !helpfulBreakpoint.matches;
          }

          const header = document.createElement(isHelpfulAccordion ? 'summary' : 'div');
          header.className = 'ip-helpful-card__header';
          const icon = document.createElement('span');
          icon.className = 'ip-helpful-card__icon';
          icon.innerHTML = helpfulDetailIcons[type];
          const cardTitle = document.createElement('h3');
          cardTitle.textContent = title;
          header.append(icon, cardTitle);
          card.append(header);

          if (items) {
            const list = document.createElement('ol');
            list.className = 'ip-helpful-card__list';
            items.forEach((itemText) => {
              const item = document.createElement('li');
              item.textContent = itemText;
              list.append(item);
            });
            card.append(list);
          } else {
            const paragraph = document.createElement('p');
            paragraph.append(body);
            if (link) {
              const anchor = document.createElement('a');
              anchor.href = link.href;
              anchor.textContent = link.label;
              paragraph.append(anchor, link.after || '.');
            }
            card.append(paragraph);
          }

          return card;
        };

        const heading = document.createElement('h2');
        heading.id = 'ip-after-hero-title';
        heading.textContent = helpfulDetailsUi.heading;

        const grid = document.createElement('div');
        grid.className = 'ip-helpful-grid';
        grid.append(
          makeCard({
            type: 'design',
            title: helpfulDetailsUi.designTitle,
            items: [
              helpfulDetailsUi.resolution(dealProfile.size),
              helpfulDetailsUi.color,
              helpfulDetailsUi.detail,
              ...(helpfulDetailsUi.coreTip ? [helpfulDetailsUi.coreTip] : []),
              helpfulDetailsUi.proofTip
            ]
          }),
          makeCard({
            type: 'artwork',
            title: helpfulDetailsUi.artworkTitle,
            body: helpfulDetailsUi.artworkBody
          }),
          makeCard({
            type: 'shipping',
            title: helpfulDetailsUi.shippingTitle,
            body: helpfulDetailsUi.shippingBefore,
            link: { href: (window.Shopify?.routes?.root || '/') + 'policies/shipping-policy', label: helpfulDetailsUi.shippingLink }
          }),
          makeCard({
            type: 'returns',
            title: helpfulDetailsUi.returnsTitle,
            body: helpfulDetailsUi.returnsBefore,
            link: {
              href: (window.Shopify?.routes?.root || '/') + 'policies/refund-policy',
              label: helpfulDetailsUi.returnsLink,
              after: helpfulDetailsUi.returnsAfter
            }
          })
        );

        if (main.querySelector('[data-ink-deal-support]')) {
          grid.querySelectorAll('.ip-helpful-card--shipping, .ip-helpful-card--returns').forEach((card) => card.remove());
        }
        support.replaceChildren(heading, grid);
        support.dataset.ipComplete = 'true';
      }

    }

    const priceArea = info?.querySelector('.main-product-price');
    if (fixedGloss && priceArea && !priceArea.matches('[data-ink-deal-price]') && !priceArea.querySelector('.ink-gloss-unit')) {
      const unit = document.createElement('span');
      unit.className = 'ink-gloss-unit';
      unit.textContent = fixedGloss.dataset.unitNote;
      priceArea.append(unit);
    }
    const gallery = main.querySelector('.section-product-info .swiper-product');
    if (isRoll1000Deal || fixedGloss) {
      gallery?.querySelectorAll('.ip-gallery-badge').forEach((badge) => badge.remove());
    } else if (gallery && !gallery.querySelector('.ip-gallery-badge')) {
      const topBadge = document.createElement('span');
      topBadge.className = 'ip-gallery-badge ip-gallery-badge--top';
      topBadge.textContent = main.classList.contains('theme-template-suffix-landing-outdoor-test') ? 'CUSTOM · WEATHER-READY' : dealProfile.badge;
      topBadge.setAttribute('aria-hidden', 'true');
      const bottomBadge = document.createElement('span');
      bottomBadge.className = 'ip-gallery-badge ip-gallery-badge--bottom';
      bottomBadge.textContent = dealProfile.bottomBadge || 'YOUR DESIGN · YOUR SHAPE';
      bottomBadge.setAttribute('aria-hidden', 'true');
      gallery.append(topBadge, bottomBadge);
      if (is500Deal && Number(marketContext.savingsPercent) > 0) {
        const discountBadge = document.createElement('span');
        discountBadge.className = 'ip-gallery-badge ip-gallery-badge--discount';
        discountBadge.textContent = `SAVE ${marketContext.savingsPercent}%`;
        discountBadge.setAttribute('aria-hidden', 'true');
        gallery.append(discountBadge);
      }
    }

    const thumbnailRail = main.querySelector('.section-product-info [id^="x-product-thumbnail-"]');
    if (gallery && thumbnailRail) {
      thumbnailRail.setAttribute('aria-label', isMatte200Deal ? matte200Ui.chooseImage : 'Choose a product image');
      thumbnailRail.querySelectorAll('button').forEach((button, index) => {
        button.setAttribute('aria-label', `${isMatte200Deal ? matte200Ui.viewImage : 'View product image'} ${index + 1}`);
      });

      const galleryLayout = gallery.closest('.splide-image');
      if (isRoll1000Deal) {
        galleryLayout?.querySelector('.ip-gallery-rail-header')?.remove();
      } else if (galleryLayout && !galleryLayout.querySelector('.ip-gallery-rail-header')) {
        const railHeader = document.createElement('div');
        railHeader.className = 'ip-gallery-rail-header';
        const label = document.createElement('strong');
        label.textContent = isMatte200Deal ? matte200Ui.moreViews : 'More Views';
        const hint = document.createElement('span');
        hint.textContent = isMatte200Deal ? matte200Ui.galleryHint : 'Choose an image or use the arrows';
        railHeader.append(label, hint);
        thumbnailRail.before(railHeader);
      }
    }
  };

  const initShowcaseCarousel = (carousel) => {
      if (carousel.dataset.ipShowcaseReady === 'true') return;

      const shell = carousel.closest('.ip-shell');
      const track = carousel.querySelector('[data-ip-showcase-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-ip-showcase-slide]'));
      const previous = shell?.querySelector('[data-ip-showcase-prev]');
      const next = shell?.querySelector('[data-ip-showcase-next]');
      const status = carousel.querySelector('[data-ip-showcase-status]');
      if (!track || !slides.length || !previous || !next) return;

      carousel.dataset.ipShowcaseReady = 'true';
      let activeIndex = 0;
      let autoplayTimer;
      let scrollTimer;
      const autoplayEnabled = carousel.dataset.autoplay !== 'false';
      const interval = Math.max(3000, Number(carousel.dataset.interval) || 5000);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const visibleCount = () => {
        const firstWidth = slides[0]?.getBoundingClientRect().width || track.clientWidth;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return Math.max(1, Math.floor((track.clientWidth + gap) / (firstWidth + gap)));
      };

      const maxIndex = () => Math.max(0, slides.length - visibleCount());

      const updateStatus = () => {
        if (status) status.textContent = `Showing showcase item ${activeIndex + 1} of ${slides.length}`;
      };

      const goTo = (index, smooth = true) => {
        const maximum = maxIndex();
        activeIndex = index > maximum ? 0 : index < 0 ? maximum : index;
        const target = slides[activeIndex];
        if (!target) return;
        track.scrollTo({
          left: Math.max(0, target.offsetLeft - track.offsetLeft),
          behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto'
        });
        updateStatus();
      };

      const stopAutoplay = () => window.clearInterval(autoplayTimer);
      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || reduceMotion.matches || maxIndex() === 0 || document.hidden) return;
        autoplayTimer = window.setInterval(() => goTo(activeIndex + 1), interval);
      };

      const refresh = () => {
        const maximum = maxIndex();
        const canMove = maximum > 0;
        previous.hidden = !canMove;
        next.hidden = !canMove;
        if (activeIndex > maximum) goTo(maximum, false);
        startAutoplay();
      };

      previous.addEventListener('click', () => {
        goTo(activeIndex - 1);
        startAutoplay();
      });
      next.addEventListener('click', () => {
        goTo(activeIndex + 1);
        startAutoplay();
      });

      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const trackLeft = track.offsetLeft + track.scrollLeft;
          activeIndex = slides.reduce((closestIndex, slide, index) => {
            const currentDistance = Math.abs(slide.offsetLeft - trackLeft);
            const closestDistance = Math.abs(slides[closestIndex].offsetLeft - trackLeft);
            return currentDistance < closestDistance ? index : closestIndex;
          }, 0);
          activeIndex = Math.min(activeIndex, maxIndex());
          updateStatus();
        }, 100);
      }, { passive: true });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) startAutoplay();
      });
      carousel.querySelectorAll('video').forEach((video) => {
        video.addEventListener('play', stopAutoplay);
        video.addEventListener('pause', startAutoplay);
        video.addEventListener('ended', startAutoplay);
      });
      document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());
      window.addEventListener('resize', refresh, { passive: true });
      if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', refresh);

      updateStatus();
      window.requestAnimationFrame(refresh);
  };

  const showcaseObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          showcaseObserver.unobserve(entry.target);
          initShowcaseCarousel(entry.target);
        });
      }, { rootMargin: '400px 0px' })
    : null;

  const enhanceShowcase = () => {
    main.querySelectorAll('[data-ip-showcase-carousel]').forEach((carousel) => {
      if (carousel.dataset.ipShowcaseReady === 'true' || carousel.dataset.ipShowcaseObserved === 'true') return;
      if (!showcaseObserver) {
        initShowcaseCarousel(carousel);
        return;
      }

      carousel.dataset.ipShowcaseObserved = 'true';
      showcaseObserver.observe(carousel);
    });
  };

  const enhanceReviewAccessibility = () => {
    let updatedButtons = 0;
    main.querySelectorAll('.jm-media-grid').forEach((grid) => {
      grid.setAttribute('role', 'tablist');
      grid.querySelectorAll('.jm-media-grid__item[aria-selected]').forEach((button) => {
        button.setAttribute('role', 'tab');
        updatedButtons += 1;
      });
    });
    return updatedButtons > 0;
  };

  let enhancementFrame = 0;
  const runEnhancements = () => {
    enhancementFrame = 0;
    enhanceHero();
    enhanceShowcase();
  };
  const scheduleEnhancements = () => {
    if (enhancementFrame) return;
    enhancementFrame = window.requestAnimationFrame(runEnhancements);
  };

  helpfulBreakpoint.addEventListener('change', ({ matches }) => {
    main.querySelectorAll('.ip-after-hero-support details.ip-helpful-card').forEach((card) => {
      card.open = !matches;
    });
  });

  scheduleEnhancements();

  if (!enhanceReviewAccessibility()) {
    const reviewObserver = new MutationObserver((mutations) => {
      const reviewChanged = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches?.('.jm-media-grid, .jm-media-grid__item') || node.querySelector?.('.jm-media-grid, .jm-media-grid__item'))
        )
      );
      if (reviewChanged && enhanceReviewAccessibility()) reviewObserver.disconnect();
    });
    reviewObserver.observe(main, { childList: true, subtree: true });
    window.setTimeout(() => reviewObserver.disconnect(), 15000);
  }

  document.addEventListener('shopify:section:load', scheduleEnhancements);
})();


